<div *ngIf="this.viewSession === 2">
 <div class="basicrow f-lsemi roboto-r text-center">
      <div class="basicrow">
          <img width="100%" class="mc-icon" src="../../assets/images/reg-a-icon.png">
          Código de Seguridad
      </div>
  </div>

  <div>
      <div class="basicrow m-top-i">
            <label class="label-f">Código de Confirmación</label>
            <input type="password" autocomplete="off" placeholder="Código de seguridad" maxlength="6" class="inp-f qt" [(ngModel)]="this.securityCode">

            <label class="label-f" style="padding-top: 10px;">¿No has recibido el código de seguridad? <a class="linkdefs">Reenviar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a></label>
      </div>
      <div class="basicrow m-top-i">
          <label class="label-f">4 &uacute;ltimos de SSN</label>

          <div class="basicrow">
              <input type="password" maxlength="4" class="inp-f" [(ngModel)]="this.ssn" autocomplete="off">
          </div>
      </div>

      <div class="basicrow m-top-i">
          <label class="label-f">Correo Electr&oacute;nico</label>

          <div class="basicrow">
              <input class="inp-f" [(ngModel)]="this.email">
          </div>
      </div>

      <div class="basicrow text-center m-top-i">
          <a class="linkdefs" (click)="this.terms()">T&eacute;rminos y Condiciones</a><br/>
          He le&iacute;do, entiendo y acepto estos t&eacute;rminos y condiciones&nbsp;&nbsp;<input type="checkbox" [(ngModel)]="this.acceptedTerms">
      </div>

      <div class="basicrow m-top-i">
          <a (click)="this.submitForm();" class="btns vcenter" [ngClass]="{gray: !this.validateInputs(), red: this.validateInputs()}">
              <span class="tabcell">
                  Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
              </span>
          </a>
      </div>
  </div>
</div>
